//imports
import {
    MANUFACTURER_CREATE_EDIT_OPEN_MODAL,
    MANUFACTURER_CREATE_REQUEST,
    MANUFACTURER_CREATE_RESULT,
    MANUFACTURER_EDIT_REQUEST,
    MANUFACTURER_EDIT_RESULT,
    MANUFACTURER_GET_REQUEST,
    MANUFACTURER_GET_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    manufacturer: null,
    current: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MANUFACTURER_GET_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURER_GET_RESULT:
            return { ...state, loading: false, manufacturer: action.payload }

        case MANUFACTURER_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, current: action.payload.man }

        case MANUFACTURER_CREATE_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURER_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case MANUFACTURER_EDIT_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURER_EDIT_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "MANUFACTURER_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};